import {createAction, props} from '@ngrx/store';
import {ILocation} from '../../models/ILocation';
import {ICheckInRequest} from '../../pages/check-in-pages/check-in/check-in.page';
import {ILocationPersonalInfo} from '../../models/IAppState';
import {ICheckinResponse} from '../../models/ICheckinResponse';
import {ICheckin} from '../../models/ICheckin';
import {INearbyRequest} from '../../models/INearbyRequest';
import {ICheckinsRequest} from '../../models/ICheckinsRequest';

export const getLocations = createAction('getLocations');
export const getLocationsSuccess = createAction('getLocationsSuccess', props<{ locations: ILocation[] }>());
export const getLocationsError = createAction('getLocationsError');

export const getLocation = createAction('getLocation', props<{ id: string }>());
export const getLocationSuccess = createAction('getLocationSuccess', props<{ selectedLocation: ILocation }>());
export const getLocationError = createAction('getLocationError', props<any>());

export const getCheckIns =
  createAction('getCheckIns', props<ICheckinsRequest>());
export const getCheckInsSuccess = createAction('getCheckInsSuccess', props<{ checkIns: ICheckinResponse }>());
export const getCheckInsError = createAction('getCheckInsError');

export const getCheckIn = createAction('getCheckIn', props<{ id: string, silent?: boolean  }>());
export const setCheckIn = createAction('setCheckIn', props<{ id: string, checkin?: ICheckin  }>());
export const getCheckInSuccess = createAction('getCheckInSuccess', props<{ selectedCheckIn: ICheckin }>());
export const getCheckInError = createAction('getCheckInError');

export const getNearby = createAction('getNearby', props<INearbyRequest>());
export const getNearbySuccess = createAction('getNearbySuccess', props<{ locations: ILocation[] }>());
export const getNearbyError = createAction('getNearbyError');

export const addLocationPersonalInfo = createAction('addLocationPersonalInfo', props<{ locationPersonalInfo: ILocationPersonalInfo }>());
export const removeLocationPersonalInfo = createAction('removeLocationPersonalInfo', props<{ locationId: string }>());

export const checkIn = createAction('CHECK_IN', props<{ request: ICheckInRequest }>());
